export default __webpack_public_path__ + "static/media/point_goal.8d18f1bc.svg";